module.exports = __webpack_public_path__ + "img/tips1_botlist3img3.df111a10.jpg";